<!--
/*******************************************************************************
*@ 컴포넌트명   : ProgressBar.vue
*@ 컴포넌트설명 : progressbar 공통컴포넌트
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <div class="progress-group">
    <div class="option option-1">
      <span class="end">
        <slot name="term" />
      </span>
    </div>
    <div class="progress">
      <div class="value" :style="{ width: percent + '%' }">
        <span class="ing">
          <slot name="ing" />
        </span>
      </div>
      <div class="division">
        <span class="line"></span>
        <span class="line"></span>
        <span class="line"></span>
        <span class="line"></span>
        <span class="line"></span>
        <span class="line"></span>
      </div>
      <div class="progress-bar" :style="{ width: percent + '%' }">
        <div class="bar"></div>
      </div>
    </div>
    <div class="option option-2">
      <div class="start">
        <span>
          <slot name="start" />
        </span>
      </div>
      <div class="end">
        <span>
          <slot name="end" />
        </span>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped></style>
<script>
export default {
  name: "ProgressBar",
  props: {
    percent: {
      type: Number,
    },
  },
};
</script>
